<template>
  <div id="app">
    <!-- 插入banner -->
    <common-banner v-if="$route.meta.bannerEnable"></common-banner>

    <common-navigate
      v-if="$route.meta.commonNavEnable"
      v-model="navigateRoute"
      @navigate="handlerNavigate"
      @navigateToHome="handlerNavigateToCaseList"
    ></common-navigate>
    <router-view
      :style="{
        height: `calc((100% - ${bannerHeight}px) - ${navigateHeight}px)`
      }"
      v-if="isRouterAlive"
    ></router-view>
    <!--插入footer-->
  </div>
</template>

<script>
import CommonBanner from "./components/common/commonBanner";
import CommonNavigate from "./components/common/commonNavigate";

export default {
  name: "App",
  provide() {
    return {
      reload: this.reloadPage
    };
  },
  data() {
    return {
      navigateRoute: "home",
      isRouterAlive: true
    };
  },
  computed: {
    bannerHeight: function() {
      return this.$route.meta.bannerEnable ? 120 : 0;
    },
    navigateHeight: function() {
      return this.$route.meta.bannerEnable ? 60 : 0;
    }
  },
  // created() {
  //   cookie.get('language') ||
  //     let language =
  //       localStorage.getItem("useLanguage") ||
  //       navigator.language.toLocaleLowerCase().substring(0, 2);
  //   this.$i18n.locale = language;
  //   console.log(this.$i18n);
  // },
  components: { CommonNavigate, CommonBanner },
  methods: {
    reloadPage() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    handlerNavigate: function(params) {
      if (this.$route.path !== `/${params}`) {
        this.$router.push(params);
      }
    },
    handlerNavigateToCaseList: function() {
      // console.log("method:App -- line:52 -- ",this.$route.query.navigateTo)
      if (
        this.$route.query.navigateTo == "myCases" ||
        this.$route.query.navigateTo == "designCenterCases" ||
        this.$route.query.navigateTo == "patientList"
      ) {
      } else {
        this.$router.push({ path: "/home", query: { navigateTo: "myCases" } });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue